/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

/* 🧩 COMPONENTS */
import { Button, Input, InputImage, InputPassword, InputSelect, Label, Modal, Pagination, Filters, CustomLoading, Breadcrumb, SaveIcon } from "../../../Components";

/* 🔗 SERVICE */
import { UserServices } from "../../../Services/userServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeLoations, changeModal, changeLoationtypes } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Lupa } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, ListButton, PageTitle, ContainerList, HeaderContainer, 
    InputContainer, FilterInput, ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn, ContentHeader } from "./styles";

/* 🔧 UTILS */
import { isValidEmail, isValidField, isValidPassword, isValidPassword2, isValidPhone, isValidUser, isValidWpp } from "../../../util/validate";

const options = [
    {id: 'roles', label: 'position'},
    {id: 'allocations', label: 'allocation'},
];

let OptionContent = {
    'roles': [],
    'allocations': [],
}

const language = [
    { id: "pt", name: "Português (Brasil)" },
    { id: "en", name: "Inglês (USA)" }
];

const ListUsers = () => {
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.employees.list.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/funcionarios' },
        { text: 'employees', page: '/adm/funcionarios' }
    ]
    
    const [isLoading, setIsLoading] = useState(true);
    const [visible, setVisible] = useState(false);
    const [users, setUsers] = useState([]);
    
    const Services = useRef(new UserServices());
    
    const AllUsers = useRef([]);
    const rolesFilter = useRef([]);
    const allocationsFilter = useRef([]);
    const nameFilter = useRef('');
    
    const ImageValue = useRef();
    
    const alocacao_typeField = useRef();
    const alocacaoField = useRef();
    const CargoField = useRef();
    const NameField = useRef();
    const UserField = useRef();
    const LanguageField = useRef();
    const PhoneField = useRef();
    const WhatsappField = useRef();
    const MailField = useRef();
    const passwordField = useRef();
    const confirmpasswordField = useRef();
    
    const alocacaoValue = useRef(null);
    const CargoValue = useRef(null);
    const NameValue = useRef(null);
    const UserValue = useRef(null);
    const LanguageValue = useRef();
    const PhoneValue = useRef(null);
    const WhatsappValue = useRef(null);
    const MailValue = useRef(null);
    const passwordValue = useRef(null);
    const confirmpasswordValue = useRef(null);
    
    const user = useSelector(state => state.userReducer);
    const Locations = useSelector(state => state.UserCurdReducer.Locations);
    const LocationTypes = useSelector(state => state.UserCurdReducer.LocationTypes);
    const Roles = useSelector(state => state.UserCurdReducer.Cargos);
    let active = useSelector(state => state.ModalReducer.name);

    const getUsers = async() => {
        setIsLoading(true)
        let Users = await Services.current.getAllUser();
        AllUsers.current = Users
        setUsers(Users)
        setIsLoading(false)
    }
    
    // Busca alocações do usuário
    const getLocations = async() => {
        try {
            let AllLocations = await Services.current.getLocations();
            let Types = Object.keys(AllLocations).map(type => {
                return{
                    id: type,
                    name: type
                }
            })
            store.dispatch(changeLoations([]));
            store.dispatch(changeLoationtypes(Types));
        } catch (error) {
            console.log(error);
        }
    }

    const GetFilters = async() =>{
        try {
            let Allocations = await Services.current.getAuthorizedAllocations();
            let cargos = await Services.current.getAuthorizedCargos();
            if(Allocations){
                OptionContent.allocations = Allocations.authorized_allocations
            }
            if(cargos){
                OptionContent.roles = cargos
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        getUsers();
        getLocations();
        GetFilters();
    }, [])

    const Aplyfilter = async() => {
        setIsLoading(true)
        let Users = await Services.current.getAllUser(null, nameFilter.current, rolesFilter.current, allocationsFilter.current);
        AllUsers.current = Users
        setUsers(Users)
        setIsLoading(false)
    }

    const ChangeFilter = (type, option, value) => {
        if(value){
            if(type === 'allocations'){
                allocationsFilter.current.push(option)
            }else if(type === 'roles'){
                rolesFilter.current.push(option)
            }
        }else{
            if(type === 'allocations'){
                let indexToRemove = allocationsFilter.current.indexOf(option);
                if (indexToRemove !== -1) {
                    allocationsFilter.current.splice(indexToRemove, 1);
                }
            }else if(type === 'roles'){
                let indexToRemove = rolesFilter.current.indexOf(option);
                if (indexToRemove !== -1) {
                    rolesFilter.current.splice(indexToRemove, 1);
                }
            }
        }
    }

    // Salva as edições do usuário
    const SaveUser = async() => {
        if(isValidUser(UserValue.current) && isValidField(NameValue.current) && isValidField(alocacaoValue.current) &&
        isValidField(PhoneValue.current) && isValidField(MailValue.current) && isValidPassword(passwordValue.current) &&
        isValidField(CargoValue.current) && isValidPassword2(passwordValue.current, passwordValue.current)){
            let form = new FormData();
            
            if(ImageValue.current){form.append('hidden_file_image', ImageValue.current)}
            if(UserValue.current){form.append('username', UserValue.current)}
            if(NameValue.current){form.append('name', NameValue.current)}
            if(alocacaoValue.current){form.append('id_allocation', alocacaoValue.current)}
            if(CargoValue.current){form.append('role_id', CargoValue.current)}
            if(PhoneValue.current){form.append('phone', PhoneValue.current)}
            if(WhatsappValue.current){form.append('whatsapp', WhatsappValue.current)}
            if(MailValue.current){form.append('email', MailValue.current)}
            if(passwordValue.current){form.append('password', passwordValue.current)}
            if(passwordValue.current){form.append('confirmpassword', confirmpasswordValue.current)}
    
            let newuser = await Services.current.SaveUser(form)
            if(newuser !== false){
                store.dispatch(changeModal(''))
                // window.location.reload()
            }
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    // Salva as edições do usuário e envia senha para o email do usuário
    const CreateNewUser = async() => {
        if(isValidUser(UserValue.current) && isValidField(NameValue.current) && isValidField(alocacaoValue.current) &&
        isValidField(PhoneValue.current) && isValidField(MailValue.current) && isValidField(CargoValue.current)){
            let form = new FormData();
            
            if(ImageValue.current){form.append('hidden_file_image', ImageValue.current)}
            if(UserValue.current){form.append('username', UserValue.current)}
            if(NameValue.current){form.append('name', NameValue.current)}
            if(alocacaoValue.current){form.append('id_allocation', alocacaoValue.current)}
            if(CargoValue.current){form.append('role_id', CargoValue.current)}
            if(PhoneValue.current){form.append('phone', PhoneValue.current)}
            if(WhatsappValue.current){form.append('whatsapp', WhatsappValue.current)}
            if(MailValue.current){form.append('email', MailValue.current)}
    
            let newuser = await Services.current.CreateNewUser(form);
            if(newuser !== false){
                store.dispatch(changeModal(''))
            }
        }else{          
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const changepage = async(page) => {
        setIsLoading(true);
        let Users = await Services.current.getAllUser(page, nameFilter.current, rolesFilter.current, allocationsFilter.current);
        AllUsers.current = Users;
        setUsers(Users);
        setIsLoading(false);
    }
    const navigate = useNavigate();

    return(
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <PageTitle>
                    {t("administrative.sub-items.employees.list.title")}
                </PageTitle>
                <HeaderContainer>
                    <ContentHeader>
                        <InputContainer>
                            <img src={Lupa} alt={t("inputs.search-employee.alt")}></img>
                            <FilterInput
                                // onBlur={()=>Aplyfilter()}
                                onKeyDown={(e) => {e.key === 'Enter' && Aplyfilter()}}
                                onChange={(e) => nameFilter.current = e.target.value}
                                placeholder={t("inputs.search-employee.placeholder")}
                            />
                        </InputContainer>

                        <Button width={'fit-content'} text={t("buttons.filter")} disabled={false} onClick={() => {setVisible(!visible); Aplyfilter();}}></Button>
                        {visible && <Filters options={options} OptionContent={OptionContent} ChangeFilter={ChangeFilter} visible={visible}/>}
                    </ContentHeader>
                    <ContentHeader>
                        <Button text={t("buttons.settings")} href='/users/admin-cruds'  onClick = {() => {navigate('/adm/funcionarios/admin-cruds')}}/>
                        {user?.user?.can?.includes('user.create') ?
                            <Button onClick={() => store.dispatch(changeModal('newuser'))} width={'fit-content'} icon={''} text={t("buttons.register-employee")}></Button>
                        :<></>}
                    </ContentHeader>
                </HeaderContainer>
                
                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + users?.total + " " + t("administrative.sub-items.employees.list.number-employees")}
                    </CountContainer>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>{t("header-table.name")}</TitleText>
                        <TitleText>{t("header-table.position")}</TitleText>
                        <TitleText>{t("header-table.allocation")}</TitleText>
                        {/* <TitleText>Inscrições</TitleText> */}
                        <TitleText $align={'center'} width={'100px'}>{t("header-table.actions")}</TitleText>
                    </LineTitle>
                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :   
                        users?.data?.map((item) => (
                            <LineList key={item.id} href={user?.user?.can?.includes('user.view') ? `/adm/perfil/${item.id}` : undefined}>
                                <ListText>{item.name}</ListText>
                                <ListText>{item.role?.title}</ListText>
                                <ListText>{item.allocation.name}</ListText>
                                {/* <ListText>{0}</ListText> */}
                                <ListText $align={'center'} width={'100px'}>
                                    <ListButton disabled={true}>...</ListButton>
                                </ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>
                <Pagination last_page={users?.last_page} currentpage={users?.current_page} changepage={changepage}/>
            </Container>
            
            <Modal title={t("modal.register-employee.title")} name={'newuser'} width={'70%'} height={'90%'} >
                {active === 'newuser' ?
                    <>
                        <ContainerRow onSubmit={(e) => e.preventDefault()}>
                            <ContainerColumn>
                                <InputImage
                                    id='foto' 
                                    name='foto' 
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => ImageValue.current = value}>
                                </InputImage>

                                <Label text={t("inputs.password.label")} aling="flex-start"/>
                                <InputPassword 
                                    id='new-password' 
                                    name='new-password' 
                                    placeholder={t("inputs.password.placeholder")}
                                    invalidMessage={t("inputs.password.invalid-message")}
                                    innerRef={passwordField}
                                    validationFunction={(text) => isValidPassword(text)}
                                    onchange={(text) => passwordValue.current = text}>
                                </InputPassword>

                                <Label text={t("inputs.confirm-password.label")} aling="flex-start"/>
                                <InputPassword 
                                    id='passwordconfirm' 
                                    name='passwordconfirm' 
                                    placeholder={t("inputs.confirm-password.placeholder")}
                                    invalidMessage={t("inputs.confirm-password.invalid-message")}
                                    innerRef={confirmpasswordField}
                                    validationFunction={(text) => isValidPassword2(text, passwordValue.current)}
                                    onchange={(text) => confirmpasswordValue.current = text}>
                                </InputPassword>                        
                            </ContainerColumn>

                            <ContainerColumn>
                                <Label text={t("inputs.user.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='user' 
                                    name='user' 
                                    type="text" 
                                    placeholder={t("inputs.user.placeholder")}
                                    innerRef={UserField}
                                    invalidMessage={t("inputs.user.invalid-message")}
                                    validationFunction={(text) => isValidUser(text)}
                                    onchange={(text) => UserValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.preferred-language.label")} aling="flex-start"/>
                                <InputSelect
                                    key="alocacao_type"
                                    name="alocacao_type"
                                    id="alocacao_type"
                                    placeholder={t("inputs.preferred-language.placeholder")}
                                    invalidMessage={t("inputs.preferred-language.invalid-message")}
                                    options={language}
                                    innerRef={LanguageField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {LanguageValue.current = value}}>
                                </InputSelect>

                                <Label text={t("inputs.allocation-type.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao_type'}
                                    name={'alocacao_type'}
                                    id={'alocacao_type'}
                                    placeholder={t("inputs.allocation-type.placeholder")}
                                    invalidMessage={t("inputs.allocation-type.invalid-message")}
                                    options={LocationTypes}
                                    innerRef={alocacao_typeField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => Services.current.ChangeLocationType(value, alocacaoField.current)}>
                                </InputSelect>

                                <Label text={t("inputs.allocation-local.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao'}
                                    name={'alocacao'}
                                    id={'alocacao'}
                                    placeholder={t("inputs.allocation-local.placeholder")}
                                    invalidMessage={t("inputs.allocation-local.invalid-message")}
                                    options={Locations}
                                    innerRef={alocacaoField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => alocacaoValue.current = value}>
                                </InputSelect>

                                <Label text={t("inputs.position.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'cargo'}
                                    name={'cargo'}
                                    id={'cargo'}
                                    placeholder={t("inputs.position.placeholder")}
                                    invalidMessage={t("inputs.position.invalid-message")}
                                    options={Roles}
                                    innerRef={CargoField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => CargoValue.current = value}>
                                </InputSelect>
                            </ContainerColumn>

                            <ContainerColumn>
                                <Label text={t("inputs.name.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='nome' 
                                    name='nome' 
                                    type="text" 
                                    placeholder={t("inputs.name.placeholder")}
                                    innerRef={NameField}
                                    invalidMessage={t("inputs.name.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => NameValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.phone.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='telefone' 
                                    name='telefone' 
                                    type="tel" 
                                    mask="(99) 99999-9999"
                                    placeholder={t("inputs.phone.placeholder")}
                                    innerRef={PhoneField}
                                    invalidMessage={t("inputs.phone.invalid-message")}
                                    validationFunction={(text) => isValidPhone(text)}
                                    onchange={(text) => PhoneValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.whatsapp.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='whatsapp' 
                                    name='whatsapp' 
                                    mask="(99) (99) 9999-9999"
                                    type="tel" 
                                    placeholder={t("inputs.whatsapp.placeholder")}
                                    innerRef={WhatsappField}
                                    invalidMessage={t("inputs.whatsapp.invalid-message")}
                                    validationFunction={(text) => isValidWpp(text)}
                                    onchange={(text) => WhatsappValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.email.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='email' 
                                    name='email' 
                                    type="text" 
                                    placeholder={t("inputs.email.placeholder")}
                                    innerRef={MailField}
                                    invalidMessage={t("inputs.email.invalid-message")}
                                    validationFunction={(text) => isValidEmail(text)}
                                    onchange={(text) => MailValue.current = text}> 
                                </Input>
                            </ContainerColumn>
                        </ContainerRow>
                        
                        <ButtonsContainer>
                            <Button text={t("buttons.submit-password-email")} width={'300px'} onClick={() => CreateNewUser()}/>
                        </ButtonsContainer>
                        <ButtonsContainer>
                            <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => SaveUser()}/>
                            <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={() => store.dispatch(changeModal(''))}/>
                        </ButtonsContainer>
                    </>
                :<></>}
            </Modal>
        </>
    )
}

export default ListUsers;